<template>
    <v-dialog v-model="objTasa.abrirDialogo" :max-width="tamModal" :fullscreen="$root.isTouch" :scrollable="$root.isTouch == false" persistent>
        <v-card>
            <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="objTasa.titulo"></span></v-card-title>

            <!-- Modal Agregar -->
            <v-dialog v-model="objTasaModal.abrirModal" :max-width="tam" :fullscreen="$root.isTouch"
                :scrollable="$root.isTouch == false" persistent>
                <v-card>
                    <v-card-title class="bg-title-card"> <span class="white--text headline" v-html="objTasaModal.titulo"></span></v-card-title>
                    <v-form ref="form_tasa_vehiculo">
                        <v-container fluid grid-list-sm>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field v-if="objTasa.nombreTabla === 'edad'" label="Rango Inicial *"
                                        color="textbox" v-model="objTasaModal.valor_min" outlined dense
                                        :rules="_.concat(requeridoRegla,soloNumerosRegla(1,objTasaModal.valor_min,2))" />

                                    <v-text-field v-else-if="objTasa.nombreTabla === 'anio'" label="Rango Inicial *"
                                        color="textbox" v-model="objTasaModal.valor_min"
                                        :rules="_.concat(requeridoRegla,soloNumerosRegla(4,objTasaModal.valor_min,4))"
                                        outlined dense />

                                    <v-text-field v-else label="Rango Inicial *" color="textbox"
                                        v-model="objTasaModal.valor_min" outlined dense
                                        :rules="_.concat(requeridoRegla,decimal)" />
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-text-field v-if="objTasa.nombreTabla === 'edad'" label="Rango Final *"
                                        color="textbox" v-model="objTasaModal.valor_max" outlined dense
                                        :rules="_.concat(requeridoRegla,soloNumerosRegla(1,objTasaModal.valor_max,2))" />

                                    <v-text-field v-else-if="objTasa.nombreTabla === 'anio'" label="Rango Final *"
                                        color="textbox" v-model="objTasaModal.valor_max"
                                        :rules="_.concat(requeridoRegla, soloNumerosRegla(4,objTasaModal.valor_max,4))"
                                        outlined dense />

                                    <v-text-field v-else label="Rango Final *" color="textbox"
                                        v-model="objTasaModal.valor_max" outlined dense
                                        :rules="_.concat(requeridoRegla,decimal)" />
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-autocomplete label="Estado *" color="textbox" v-model="objTasaModal.idEstado"
                                        :items="listEstados" item-text="nombre_estado" item-value="id_estado"
                                        :rules="requeridoRegla" outlined dense></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="text-right">
                                    <v-btn outlined rounded color="danger" v-html="'Salir'" class="mr-1" @click="cerrarModal"></v-btn>
                                    <v-btn rounded dark color="primary" v-html="'Guardar'" @click="guardar"></v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card>
            </v-dialog>
            <!-- Fin Modal Agregar -->

            <v-card-text>
                <v-container fluid grid-list-md>
                    <v-row dense>
                        <v-col class="text-right">
                            <v-btn rounded dark color="primary" @click="objTasaModal.abrirModal = true" v-html="'Nuevo'"/>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12" sm="6"/>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Buscar" color="textbox" v-model="objTasa.busqueda" clearable prepend-inner-icon="search" dense/>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <v-data-table  :search="objTasa.busqueda" :headers="cabeceraModal" :items="listDetalle" :class="objTasa.busqueda" class="elevation-3">
                                <template v-slot:item.accion="{ item }">
                                    <v-btn class="ma-2" text icon color="primary" @click="editarElemento(item)">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>     
                                </template>

                                <template v-slot:no-results>
                                    Tu búsqueda de  "<span v-text="objTasa.busqueda"></span>" no arrojó resultados.
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row >
                        <v-col class="text-right">
                            <v-btn outlined rounded color="danger" @click="reset();cerrar();">Salir</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ModalTasaComponent',
        props: ['objModal','listaDetalle','cabeceraModal','listaEstados'],
        inject: ['insertarActualizar', 'cerrar'],
        data: () => ({
            tam:'50%',
            listDetalle:[],
            currentIndex:null,
            objTasaModal:{},
            objTasa:{}
        }),
        watch:{
            listaDetalle(){
                this.listDetalle = _.size(this.listaDetalle) > 0 ? _.filter(this.listaDetalle, (o) => { return o.id != 0 }) : [];
            },
            objModal: {
                handler: function(value) {
                    if(value.abrirDialogo)
                        this.cargaGeneral();
                },
                deep: true
            }
        },
        computed:{
            listEstados(){
                var lista = [];
                if(_.size(this.listaEstados)>0)
                    lista = _.filter(this.listaEstados,function(obj){ return _.toUpper(obj.nombre_estado) != _.toUpper('TODOS') });
                            
                return lista;
            }
        },
        methods: {
            cargaGeneral(){
                this.objTasa = _.merge({},_.clone(this.objModal),{opcion  : 'I_RANGO',metodo  : 'Nuevo',idEstado: '1'});
                this.objTasaModal = {titulo: 'Nuevo Rango',abrirModal: false, idEstado: '1'};
            },
            guardar(){
                if(this.$refs.form_tasa_vehiculo.validate()){
                    if(parseInt(this.objTasaModal.valor_min) <= parseInt(this.objTasaModal.valor_max)){
                        var objeto = _.merge({},_.omit(this.objTasa,['abrirDialogo','titulo','metodo']),_.omit(this.objTasaModal,['abrirModal','titulo']));
                        
                        this.insertarActualizar('RANGO',objeto)
                            .then((r)=>{
                                if(r)
                                    this.cerrarModal();
                            })

                    }else
                        mensajesAlerta(mensajeEstandar.rangoIncorrecto,'I');
                }else
                    mensajesAlerta(mensajeEstandar.corregirInformacion,'I');
            },
            editarElemento(elemento){
                if(!_.isUndefined(elemento.id)){
                    this.objTasaModal.opcion = 'U_RANGO';
                    this.objTasaModal.metodo = 'Actualizar';
                }

                this.objTasaModal.titulo = 'Editar Rango';

                // if(_.isUndefined(elemento.index))
                //     this.objTasaModal.index =  index;
                
                this.objTasaModal = _.merge({},_.omit(this.objTasaModal,['abrirDialogo','visualiza']),elemento);
                this.objTasaModal.abrirModal =  true;

                // if(!_.isUndefined(this.objTasa.id)){
                //     this.objTasa.opcion = 'U_RANGO';
                //     this.objTasa.metodo = 'Actualizar';
                // }

                // if (!_.isNull(this.currentIndex)) {
                //     this.listDetalle[this.currentIndex] = _.merge(this.listDetalle[this.currentIndex],this.objTasa);
                // }
                // this.currentIndex = index;
                // this.objTasa = _.merge(this.objTasa,elemento);
            },
            // Modal
            guardarModal(){
                if(!_.isUndefined(this.objTasaModal.index))
                    this.listDetalle.push(this.objTasaModal);
                else
                    this.listDetalle[this.objTasaModal.index] = _.merge({},this.listDetalle[this.objTasaModal.index],this.objTasaModal);
            },
            cerrarModal(){
                this.$refs.form_tasa_vehiculo.resetValidation();
                this.objTasaModal = {titulo: 'Nuevo Rango',abrirModal: false, idEstado: '1'};
            },
            reset(){
                this.objTasa = _.merge({ opcion  : 'I_RANGO',metodo: 'Nuevo',idEstado:'1'},this.objModal);
                this.objTasa.abrirDialogo = false;
            }
        }
    }
</script>

<style>

</style>